export default "9327f73279b69223.svg"